module.exports = __webpack_public_path__ + "static/media/UY.3342fd1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/UY.svg
// module id = 385
// module chunks = 0